import React from 'react';
import { CATEGORY_LABELS } from '../constants';

export default function ExerciseInfoModal({ exercise, onClose }) {
  if (!exercise) return null;
  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 1200 }}>
      <div className="modal-sheet" onClick={e => e.stopPropagation()}>
        <div className="modal-handle" />
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
          <span className={`badge badge-${(exercise.category || 'other').toLowerCase()}`}>
            {CATEGORY_LABELS[(exercise.category || 'other').toLowerCase()] || exercise.category || 'Otro'}
          </span>
          {exercise.is_global && <span className="badge badge-admin">Admin</span>}
          {exercise.is_bodyweight && <span className="badge badge-admin" style={{ fontSize: '0.6rem' }}>Sin peso</span>}
          {exercise.muscle_group && (
            <span className="text-sm text-muted">{exercise.muscle_group}</span>
          )}
        </div>
        <div className="modal-title" style={{ marginBottom: 12 }}>{exercise.name}</div>
        {exercise.gif_url && (
          <img
            src={exercise.gif_url}
            alt={exercise.name}
            style={{ width: '100%', maxHeight: 280, objectFit: 'contain', borderRadius: 10, marginBottom: 12 }}
          />
        )}
        {exercise.description && (
          <p className="text-sm text-muted" style={{ marginBottom: 12 }}>{exercise.description}</p>
        )}
        <button className="btn btn-secondary btn-full" onClick={onClose}>Cerrar</button>
      </div>
    </div>
  );
}
